<template>
  <div v-if="chat.lastUpdated && chat.lastUpdated >= after">
    <div class="chat-conversation">
      <div class="header">
        <template v-if="members.length > 2">
          <h5><first-name v-for="(member, id) in members" :member="member['.key']" :deli="','" :presence="true" :showDeli="(id + 1 < members.length)" :key="member['.key']"></first-name></h5>
        </template>
        <template v-else><full-name v-for="(member, id) in members" v-if="member['.key'] !== $root.user.uid" :member="member['.key']" :presence="true" :key="member['.key']"></full-name></template>
      </div>
      <div class="body" id="conversation">
        <message v-for="(message, id) in messages" :message="message" v-if="message.createdAt >= after" :key="id" :index="id" :allmessages="messages"></message>
      </div>
      <input type="text" class="message" v-model="message" placeholder="Type a message..." v-on:keydown.enter.prevent="send"></input>
<!--       <textarea class="message" placeholder="Type a message..." @keyup="growBox"></textarea> -->
      <!-- <div contenteditable v-model="message" v-on:keydown.enter.prevent="send">Hello</div> -->
    </div>
    <options :chatID="id"></options>
  </div>
</template>

<script>
import { auth, db } from '@/firebase'
import Message from './Message'
import Options from './Options'
import FirstName from '@/components/chat/naming/FirstName'
import FullName from '@/components/chat/naming/FullName'
import router from '@/router'

export default {
  name: 'Conversation',
  data () {
    return {
      message: '',
      chat: {
        lastUpdated: null,
        lastMessage: null
      }
    }
  },
  props: ['id', 'after'],
  firebase () {
    return {
      messages: db.ref('chats-messages/' + this.id),
      members: db.ref('chats-members/' + this.id),
      unreads: {
        source: db.ref('chats/' + this.id + '/unreads'),
        asObject: true
      }
    }
  },
  components: {
    Message,
    Options,
    FirstName,
    FullName
  },
  methods: {
    send () {
      if (this.message !== '') {
        var timestamp = Date.now()
        this.$firebaseRefs.messages.push({
          user: this.$root.user.uid,
          content: this.message,
          createdAt: timestamp
        })
        var unreads = {}
        for (var index in this.members) {
          // console.log(this.unreads[this.members[index]['.key']])
          unreads[this.members[index]['.key']] = this.unreads[this.members[index]['.key']] + 1
          // Add notification to user
          if (this.members[index]['.key'] !== this.$root.user.uid) {
            db.ref('users/' + this.members[index]['.key'] + '/unreads').set(1)
          }
        }
        unreads[this.$root.user.uid] = 0
        // console.log(unreads)
        this.$firebaseRefs.chat.set({
          lastMessage: this.$root.profile.firstname + ': ' + this.message,
          lastUpdated: timestamp,
          unreads: unreads
        })
        this.message = ''
      } else {
        alert('Please type a message.')
      }
      this.message = ''
    },
    scrollToEnd () {
      var container = this.$el.querySelector('#conversation')
      container.scrollTop = container.scrollHeight
    },
    isMember () {
      for (var index in this.members) {
        if (this.members[index]['.key'] === this.$root.user.uid) {
          return true
        }
      }
      return false
    },
    growBox (box) {
      box.style.height = 0
      box.style.height = box.scrollHeight + 'px'
    }
  },
  updated () {
    if (this.chat && this.chat.lastUpdated) {
      if (this.chat.lastUpdated < this.after) {
        router.push('/chats')
      }
      if (this.$root.user) {
        this.$firebaseRefs.unreads.child(this.$root.user.uid).set(0)
        if (!this.isMember()) {
          router.push('/chats')
        }
      }
      this.scrollToEnd()
    }
  },
  beforeCreate: function () {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        this.$bindAsObject('chat', db.ref('chats/' + this.id))
      }
    }.bind(this))
  },
  watch: {
    'id': function (current, previous) {
      this.$bindAsObject('chat', db.ref('chats/' + current))
      this.$bindAsArray('messages', db.ref('chats-messages/' + current))
      this.$bindAsArray('members', db.ref('chats-members/' + current))
      this.$bindAsObject('unreads', db.ref('chats/' + current + '/unreads'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// Conversation.vue?ba599880